import { render, staticRenderFns } from "./form-log.vue?vue&type=template&id=36066f5a"
import script from "./form-log.vue?vue&type=script&lang=js"
export * from "./form-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports